var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!!_vm.video && !!_vm.src)?_c('video',{attrs:{"id":_vm.elId,"data-poster":_vm.poster,"controls":"","playsinline":""}},[_c('source',{attrs:{"default":"","src":_vm.src,"type":_vm.video.mimetype}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }